import { Button, HStack, Modal, ModalBody, ModalContent, ModalOverlay, useToast, } from '@chakra-ui/react';
import React, { useState } from 'react';
import { filter, uniq } from 'ramda';
import { localise } from '../../../services/lang/lang';
import { useTokens } from '../../../context/TokenProvider';
import { useCreateOfficerInvite } from '../../../services/api/generated/client';
import { RenderIf } from '../RenderIf/RenderIf';
import { ErrorAwareAlertBox } from '../ErrorAwareAlertBox/ErrorAwareAlertBox';
import { MultiEmailInput } from '../MultiEmailInput/MultiEmailInput';
import { isValidationError } from '../../../services/errors/error';
import { Alert } from '../Alert/Alert';
import { PermissionModalContent } from '../PermissionModalContent/PermissionModalContent';
import StandardModalHeader from '../Modal/StandardModalHeader';
export const InviteTeamModal = (props) => {
    const tokens = useTokens();
    const toast = useToast();
    const [stagedEmails, setStagedEmails] = useState([]);
    const [stagedRoles, setStagedRoles] = useState([]);
    const { mutate, isPending, isError, error, reset: resetMutation, } = useCreateOfficerInvite();
    const reset = () => {
        setStagedRoles([]);
        setStagedEmails([]);
    };
    const onSubmit = () => {
        mutate({
            data: {
                invites: stagedEmails,
                role_ids: stagedRoles,
            },
        }, {
            onSuccess: () => {
                reset();
                props.onClose();
                props.onSuccess?.();
                toast({
                    title: localise('INVITATIONS_SENT'),
                    description: localise('INVITATIONS_SENT_BLURB'),
                    status: 'success',
                    isClosable: true,
                });
            },
        });
    };
    const onRemoveStagedEmail = (email) => {
        const removedEmail = filter((candidate) => candidate !== email, stagedEmails);
        setStagedEmails(removedEmail);
        resetMutation();
    };
    const onAddStagedEmail = (emails) => {
        const standardEmails = emails.map((email) => email.toLowerCase());
        const emailsToStage = uniq([...stagedEmails, ...standardEmails]);
        setStagedEmails(emailsToStage);
        resetMutation();
    };
    const onAddRole = (role) => {
        setStagedRoles(uniq([...stagedRoles, role]));
    };
    const onRemoveRole = (role) => {
        setStagedRoles(stagedRoles.filter((r) => r !== role));
    };
    const onCloseProxy = () => {
        resetMutation();
        reset();
        props.onClose();
    };
    const canSubmit = stagedEmails.length > 0;
    return (React.createElement(Modal, { variant: "primary", isOpen: props.isOpen, onClose: onCloseProxy },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, null,
            React.createElement(StandardModalHeader, { title: localise('INVITE_TEAM'), closeLabel: localise('CLOSE_INVITE_TEAM_MODAL') }),
            React.createElement(RenderIf, { condition: isValidationError(error) },
                React.createElement(Alert, { status: "error" }, localise('INVITEES_INVALID'))),
            React.createElement(RenderIf, { condition: isError },
                React.createElement(RenderIf, { condition: !isValidationError(error) },
                    React.createElement(ErrorAwareAlertBox, { error: error, noun: localise('INVITE') }))),
            React.createElement(ModalBody, null,
                React.createElement(MultiEmailInput, { emails: stagedEmails, onAdd: onAddStagedEmail, onRemove: onRemoveStagedEmail }),
                React.createElement(PermissionModalContent, { checkedRoles: stagedRoles, onAddRole: onAddRole, onRemoveRole: onRemoveRole }),
                React.createElement(HStack, { mt: 4, width: "100%", justifyContent: "end", gap: tokens.Spacing06 },
                    React.createElement(Button, { variant: "secondary", onClick: onCloseProxy, "data-testid": "invite-team-modal__cancel-button" }, localise('CANCEL')),
                    React.createElement(Button, { variant: "primary", isDisabled: !canSubmit, onClick: onSubmit, isLoading: isPending, "data-testid": "invite-team-modal__submit-button" }, localise('INVITE')))))));
};
